$(document).on('click', '.js-open-project', function(e) {

    e.preventDefault();

    const _link = $(this);

    const post_id = _link.data('post_id');

    $.ajax({

        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
            action: 'load_project',
            post_id: post_id
        },

        beforeSend: function() { _link.addClass('loading'); },

        success: function(response) {

            if (!response.success) { return; }

            // add project to html
            const _project_layer = $('<div>', {

                class: 'js-project-layer',
                'data-project-id': post_id

            });

            _project_layer.html(response.data.html);

            $('.js-set-project-content-here').append(_project_layer);

            
            
            // add context to project html
            if (response.data.context_html) {

                const _context_layer = $('<div class="js-context-layer"></div>');
                _context_layer.html(response.data.context_html);
                $('.js-set-project-context-here').append(_context_layer);

                $('.js-open-context-overlay').removeClass('opacity-0 pointer-events-none');

            }

            
            
            // add link to go back to projects
            add_go_back_to_projects_link();
            
            $('body').addClass('open-project');

        },

        complete: function() {

            _link.removeClass('loading');

        }

    }); 

});


function add_go_back_to_projects_link(){

    if($('.js-back-to-projects').length == 0){
                
        const _back_to_projects_link = $('<a>', {
            href: '#',
            class: 'js-back-to-projects hover'
        });

        $('.page-title').wrap(_back_to_projects_link);
        

        $('.js-back-to-projects').on('click', function(e) {
            
            e.preventDefault();
            go_back_to_projects();

        });
        
    }

}

function go_back_to_projects(){

    $('body').removeClass('open-project');
    $('.js-set-project-content-here').empty();
    $('.js-set-project-context-here').empty();
    // activate on phase 3 $('.js-open-context-overlay').addClass('opacity-0 pointer-events-none');

}

$(document).on('go_back_to_projects', function() {

    go_back_to_projects();

});